import React, { FC, memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import Dropdown from '@/atoms/dropdown';
import { useGetPriceRangeData, useGetStaticFilters } from '@core/offices/actions/properties/filterActions';
import { StaticFilter } from '@core/offices/store/filters';

import PriceRangeMenuContent from './components/price-range-menu-content';

interface Props {
  handleSubmit: (filters: StaticFilter) => void;
}

const PriceRange: FC<Props> = ({ handleSubmit }) => {
  const { t } = useTranslation();
  const staticFilters = useGetStaticFilters();
  const { options } = useGetPriceRangeData();
  const minValue = parseInt(staticFilters.priceRange?.split('-')[0], 10);
  const maxValue = parseInt(staticFilters.priceRange?.split('-')[1], 10);

  const labelName = useMemo(() => {
    if (!minValue && !maxValue) return null;
    if (!minValue && maxValue) return t('filters.upTo', { max: maxValue });
    if (minValue && !maxValue) return t('filters.minPlus', { min: minValue });
    return t('filters.range', { min: minValue, max: maxValue });
  }, [minValue, maxValue, t]);

  return (
    <Dropdown
      className="w-40 rounded-full h-9 text-xs"
      placeholder={t('filters.priceRange')}
      options={options}
      name="priceRange"
      value={labelName}
      onChange={(e) => handleSubmit({ ...staticFilters, priceRange: e })}
      popupClassName="!w-80 p-5"
      dropdownRender={(menu) => <PriceRangeMenuContent handleSubmit={handleSubmit} menu={menu} />}
    />
  );
};
export default memo(PriceRange);
